<template>
  <div>
      <div class="widget widget-item-list widget-primary topitems" v-if="hasGetterSet==false && toparticle.length > 0" v-cloak>
        <div class="widget-inner">
          <div class="h3">
            {{ $translate("Phywe::Template.topitemsHeadline", {"categoryname": categorydetails}) }}
          </div>
          <carousel :items-per-page="5" class="my-carousel">
            <template slot="items" v-for="topitem in topitems">
              <category-item
                  :item-data="topitem.more.data"
                  :decimal-count="$ceres.config.item.storeSpecial"
                  :disable-carousel-on-mobile="true">
              </category-item>
            </template>
          </carousel>
        </div>
      </div>
  </div>
</template>

<script>
export default
{
  props: ['template','category','categorydetails'],
  data: function()
  {
    return {
      topitems:[],
      hasGetterSet:false
    };
  },
  mounted: function()
  {
    let _self = this;
    _self.getData();
    if(location.search!='')
    {
      _self.hasGetterSet = true;
    }
  },
  methods:
  {
    getData:function ()
    {
      let current = this.category;
      let _self = this;
      $.ajax(
          {
            type:           'GET',
            url:            '/YbbaPhywe/get/top/by/cat/'+current+'/9/',
            dataType:       'json',
            success:        function(data)
            {
              for(let i = 0; i < data.length;i++)
              {
                for(let l = 0; l < data[i].texts.length; l++)
                {
                  if(data[i].texts[l].lang == App.language)
                  {
                    data[i].more.data.texts = data[i].texts[l];
                  }
                }
                if(data[i].more.data.images.all.length == 0)
                {
                  data[i].more.data.images.all.push(
                      {
                        path:               "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/Generel/Image_Default.png",
                        url:                "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/Generel/Image_Default.png",
                        urlMiddle:          "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/Generel/Image_Default.png",
                        urlPreview:         "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/Generel/Image_Default.png",
                        urlSecondPreview:   "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/Generel/Image_Default.png"
                      }
                  )

                }
              }
              if(data.length > 5 && window.innerWidth > 992)
              {
                setTimeout(function()
                {
                  $('.topitems > ul').addClass('owl-carousel');
                  $('.topitems > ul').owlCarousel({
                    lazyLoad: false,
                    loop: false,
                    mouseDrag: true,
                    nav: true,
                    navClass: ["owl-single-item-nav left carousel-control list-control-special", "owl-single-item-nav right carousel-control list-control-special"],
                    navContainerClass: "",
                    navText: ["<i class=\"owl-single-item-control fa fa-chevron-left\" aria-hidden=\"true\"></i>", "<i class=\"owl-single-item-control fa fa-chevron-right\" aria-hidden=\"true\"></i>"],
                    smartSpeed: 350,
                    responsive:{
                      0:{
                        items:2
                      },
                      600:{
                        items:3
                      },
                      1000:{
                        items:5
                      }
                    }
                  })
                },500);
                //console.log('do owl');
              }
              _self.topitems = data;
            },
            error:          function(jqXHR, textStatus, errorThrown)
            {
              console.error(errorThrown);
            }
          });
    }

  },
  computed:
  {
    toparticle: function()
    {

      let _self = this;
      return _self.topitems;
    }
    }
}
</script>
